import { render, staticRenderFns } from "./JobCardCollection.vue?vue&type=template&id=6022393f"
import script from "./JobCardCollection.vue?vue&type=script&lang=js"
export * from "./JobCardCollection.vue?vue&type=script&lang=js"
import style0 from "./JobCardCollection.vue?vue&type=style&index=0&id=6022393f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports